import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × LEMAIRE: Soft intellectualism
// Earth-tone grids, folded surfaces, paper-like textures
export function VasarelyLemaireMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="lemaire-earth1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#A89F91" />
          <stop offset="50%" stopColor="#B8AFA0" />
          <stop offset="100%" stopColor="#C8BFB0" />
        </linearGradient>
        <linearGradient id="lemaire-fold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#D8CFBE" stopOpacity="1" />
          <stop offset="50%" stopColor="#C8BFB0" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#B8AFA0" stopOpacity="0.2" />
        </linearGradient>
        <filter id="lemaire-paper">
          <feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" />
          <feColorMatrix values="0 0 0 0 0.9, 0 0 0 0 0.9, 0 0 0 0 0.85, 0 0 0 1 0" />
        </filter>
      </defs>

      {/* Paper-like neutral background */}
      <rect x="0" y="0" width="794" height="1123" fill="#E8DFD0" />
      <rect x="0" y="0" width="794" height="1123" fill="#E8DFD0" filter="url(#lemaire-paper)" opacity="0.1" />

      <g transform="translate(397 540)">
        {/* Modular earth-tone grid */}
        {Array.from({ length: 10 }).map((_, i) =>
          Array.from({ length: 14 }).map((_, j) => {
            const x = (i - 4.5) * 70;
            const y = (j - 6.5) * 75;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 32}
                y={y - 35}
                width="64"
                height="70"
                fill="none"
                stroke="#A89F91"
                strokeWidth="1"
                opacity="0.25"
              />
            );
          })
        )}

        {/* Folded surfaces illusion */}
        {[
          { x: -180, y: -220, w: 150, h: 180, angle: 5 },
          { x: 30, y: -220, w: 150, h: 180, angle: -5 },
          { x: -180, y: 40, w: 150, h: 180, angle: -3 },
          { x: 30, y: 40, w: 150, h: 180, angle: 3 },
        ].map((fold, i) => (
          <g key={i} transform={`rotate(${fold.angle} ${fold.x + fold.w / 2} ${fold.y + fold.h / 2})`}>
            <rect
              x={fold.x}
              y={fold.y}
              width={fold.w}
              height={fold.h}
              fill="url(#lemaire-fold)"
              stroke="#A89F91"
              strokeWidth="1"
              opacity="0.4"
            />
            {/* Fold line */}
            <line
              x1={fold.x}
              y1={fold.y + fold.h / 2}
              x2={fold.x + fold.w}
              y2={fold.y + fold.h / 2}
              stroke="#8E857A"
              strokeWidth="1.5"
              opacity="0.3"
            />
          </g>
        ))}

        {/* Soft intellectualism circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 50 + i * 28;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#B8AFA0"
              strokeWidth="1"
              opacity={0.3 - i * 0.025}
            />
          );
        })}

        {/* Central neutral medallion */}
        <rect x="-100" y="-100" width="200" height="200" fill="url(#lemaire-earth1)" opacity="0.3" />
        <rect x="-90" y="-90" width="180" height="180" fill="none" stroke="#A89F91" strokeWidth="2" />
        <rect x="-80" y="-80" width="160" height="160" fill="none" stroke="#B8AFA0" strokeWidth="1" />

        {/* Craft texture lines */}
        {Array.from({ length: 20 }).map((_, i) => {
          const y = -90 + i * 9;
          return (
            <line
              key={i}
              x1="-80"
              y1={y}
              x2="80"
              y2={y}
              stroke="#C8BFB0"
              strokeWidth="0.5"
              opacity="0.3"
            />
          );
        })}
      </g>

      {/* Soft intellectualism */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#A89F91" letterSpacing="2">
        intellectualisme doux
      </text>
    </g>
  );
}
